export default __webpack_public_path__ + "static/media/car.a40887a2.png";